module.exports = __webpack_public_path__ + "static/media/fish.cf9bb64d.svg";